class SubtleCountdown extends HTMLElement {
  connectedCallback() {
    this.target = new Date(this.dataset.launchAt);
    this.mode = this.dataset.mode;
    this.parts = {
      days: this.querySelector('[data-countdown="days"]'),
      hours: this.querySelector('[data-countdown="hours"]'),
      minutes: this.querySelector('[data-countdown="minutes"]'),
      seconds: this.querySelector('[data-countdown="seconds"]'),
    };
    this.enterButton = this.querySelector('[data-enter-button]');
    this.handleEnterClick = this.openPasswordModal.bind(this);
    this.enterButton?.addEventListener('click', this.handleEnterClick);
    this.tick();
    this.timer = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
    this.enterButton?.removeEventListener('click', this.handleEnterClick);
  }

  tick() {
    if (this.mode === 'enter' || Number.isNaN(this.target.getTime())) {
      this.classList.add('subtle-password--enter');
      return;
    }

    const remaining = this.target.getTime() - Date.now();
    if (remaining <= 0) {
      this.classList.add('subtle-password--enter');
      window.clearInterval(this.timer);
      return;
    }

    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);

    this.parts.days.textContent = String(days).padStart(2, '0');
    this.parts.hours.textContent = String(hours).padStart(2, '0');
    this.parts.minutes.textContent = String(minutes).padStart(2, '0');
    this.parts.seconds.textContent = String(seconds).padStart(2, '0');
  }

  openPasswordModal() {
    const passwordToggle = document.querySelector('.password-modal summary');
    passwordToggle?.click();
  }
}

customElements.define('subtle-countdown', SubtleCountdown);
